// /* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { Subheader, Paper, CircularProgress } from 'material-ui';
import { filter, map } from 'lodash';
import moment from 'moment';

import PanelMessage from 'components/panels/PanelMessage';
import { fetchPensionData } from 'actions/EmployeePensionAndUnion';
import styles from './styles/Cards';
// import { renderList } from './helpers';

const EmployeePension = ({
  fetchPension,
  pensions,
  privatePensions,
  pensionLoading,
  pensionError,
  detailId,
}) => {

  useEffect(() => {
    fetchPension(detailId);
  }, []);

  const latestPension = filter(pensions, p => moment().isBetween(moment(p.Begda), moment(p.Endda)));

  const latestPrivatePension = filter(privatePensions, p => moment().isBetween(moment(p.Begda), moment(p.Endda)));

  const renderRow = obj => (
    <div style={styles.row} key={obj.EmployeeDetailPensionID}>
      <div style={styles.col1}>
        <span style={styles.label}><FormattedMessage id="Pension.fund.number" /></span>
        <p>{obj.PayPensionID}</p>
      </div>
      <div style={styles.col2}>
        <span style={styles.label}><FormattedMessage id="Pension.fund" /></span>
        <p>{obj.PayPensionName}</p>
      </div>
      <div style={{ ...styles.col3, ...styles.alignRight }}>
        <span style={styles.label}><FormattedMessage id="Pension.employee.percentage" /></span>
        <p>{obj.PercentEmployee}</p>
      </div>
      <div style={{ ...styles.col4, ...styles.alignRight }}>
        <span style={{ ...styles.label, whiteSpace: 'nowrap', marginLeft: 8 }}><FormattedMessage id="Pension.company.percentage" /></span>
        <p>{obj.PercentCompany}</p>
      </div>
    </div>
  );

  if (pensionLoading) return <Paper style={styles.loading}><CircularProgress /></Paper>;

  if (pensionError) {
    return (<PanelMessage
      type="error"
      iconName="error"
      zDepth={1}
      message={pensionError.Message || <FormattedMessage id="error" values={{ name: <FormattedMessage id="Pension.fund" /> }} />}
    />);
  }

  // const msg = str => (
  //   <PanelMessage style={{ paddingLeft: '0px !important' }} zDepth={1} message={<FormattedMessage id={str} />} iconName="info" type="info" />
  // );

  return (
    <React.Fragment>
      <Subheader style={styles.subheader}><FormattedMessage id="Pension.fund" /></Subheader>
      {latestPension.length
        ? (
          <Paper zDepth={1}>
            {map(latestPension, p => renderRow(p))}
          </Paper>
        ) : <PanelMessage
          zDepth={1}
          message={<FormattedMessage id="No.pension.fund" />}
          iconName="info"
          type="info"
        />
      }
      <Subheader style={styles.subheader}><FormattedMessage id="Private.pension.fund" /></Subheader>
      {latestPrivatePension.length
        ? (
          <Paper zDepth={1}>
            {map(latestPrivatePension, p => renderRow(p))}
          </Paper>
        ) : <PanelMessage
          zDepth={1}
          message={<FormattedMessage id="No.private.pension.fund" />}
          iconName="info"
          type="info"
        />
      }
    </React.Fragment>
  );
};

EmployeePension.propTypes = {
  fetchPension: PropTypes.func,
  pensions: PropTypes.array,
  privatePensions: PropTypes.array,
  pensionLoading: PropTypes.bool,
  pensionError: PropTypes.object,
  detailId: PropTypes.number,
};

const mapStateToProps = ({ EmployeePensionAndUnionReducer }) => ({
  pensions: EmployeePensionAndUnionReducer.pensions,
  privatePensions: EmployeePensionAndUnionReducer.privatePensions,
  pensionLoading: EmployeePensionAndUnionReducer.pensionLoading,
  pensionError: EmployeePensionAndUnionReducer.pensionError,
});

const mapDispatchToProps = dispatch => ({
  fetchPension: detailId => dispatch(fetchPensionData(detailId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeePension);



// WEBPACK FOOTER //
// ./src/containers/pay/EmployeePension.js